import {
  LOADING,
  PENDING_LIST_FAILED,
  PENDING_LIST_SUCCESS,
  PENDING_LIST_NOT_FOUND,
  NETWORK_ERROR_PENDING_LIST,
  RESET_PENDING_LIST,
  CANCEL_PENDINGLIST_FAILED,
  CANCEL_PENDINGLIST_SUCCESS,
  NETWORK_ERROR_CANCEL_PENDING_LIST,
  NETWORK_ERROR_SEND_PENDING_LIST
} from "../types";

const initialState = {
  isLoading: false
};

export default (state = initialState, action) => {
  switch (action.type) {
    case LOADING:
      return {
        ...state,
        isLoading: true
      };

    case PENDING_LIST_FAILED:
    case PENDING_LIST_SUCCESS:
    case PENDING_LIST_NOT_FOUND:
    case NETWORK_ERROR_PENDING_LIST:
    case RESET_PENDING_LIST:
    case CANCEL_PENDINGLIST_FAILED:
    case CANCEL_PENDINGLIST_SUCCESS:
    case NETWORK_ERROR_CANCEL_PENDING_LIST:
    case NETWORK_ERROR_SEND_PENDING_LIST:
      return { ...state, isLoading: false };

    default:
      return state;
  }
};
